import React from 'react'
import {useTranslation} from 'react-i18next'
import store from "@formApp/store"

export default () => {
  const {t, i18n} = useTranslation();
  const {formValues} = React.useContext(store);
  const values = {
    siteName: formValues.getValue('siteName'),
    domain: formValues.getValue('domain'),
    Email: formValues.getValue('Email')
  };
  return (
    <>
      <header className="form-heading">
        <h2>{t('Ti abbiamo inviato un\'email')}</h2>
      </header>
      <div className="feedback ok">
        <p>
          <span className="altervista-icon icon-mail"></span>
          {t('Abbiamo avviato la registrazione del dominio {{siteName}}{{domain}}, l’operazione potrebbe richiedere fino a 48h, riceverai una email di conferma all’indirizzo {{Email}}', values)}
        </p>
      </div>
      <p>
      <a target="_blank" href={`/feedback.php?who=feedback&amp;lang=${i18n.language}`}>{t('Scrivi qui')}</a> {t('per eventuali problemi')}.
      </p>
      <p className="text-center">
        <a className="button" href="/">{t('Torna alla pagina principale')}</a>
      </p>
    </>
  )
}